import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LinksMap } from 'models/api';

interface BaseLinksState {
  map: LinksMap | undefined;
  selectedSiteUuid?: string;
}

export const SiteUuidKey = 'site_uuid';

const storedSiteUuid = localStorage.getItem(SiteUuidKey);
const searchParams = new URLSearchParams(window.location.search);
let initialSiteUuid: string | undefined = undefined;

if (storedSiteUuid) {
  initialSiteUuid = storedSiteUuid;
}

if (searchParams.get(SiteUuidKey)) {
  const siteUuid = searchParams.get(SiteUuidKey) as string;

  localStorage.setItem(SiteUuidKey, siteUuid);
  initialSiteUuid = siteUuid;
}

const initialState: BaseLinksState = {
  map: undefined,
  selectedSiteUuid: initialSiteUuid,
};

const BaseLinksSlice = createSlice({
  name: 'base_links',
  initialState,
  reducers: {
    setLinks(state: BaseLinksState, action: PayloadAction<LinksMap>) {
      state.map = action.payload;
    },
    setSiteUuid(state: BaseLinksState, action: PayloadAction<string>) {
      state.selectedSiteUuid = action.payload;
      localStorage.setItem(SiteUuidKey, action.payload);
    },
  },
});

export const { setLinks, setSiteUuid } = BaseLinksSlice.actions;

export const BaseLinksReducer = BaseLinksSlice.reducer;

export default BaseLinksSlice;
